import GlobeIcon from '../../../icons/activities/globe.svg'
import EmailIcon from '../../../icons/email.svg'
import InformationIcon from '../../../icons/info.svg'
import PhoneIcon from '../../../icons/phone.svg'

export const QA_NAME_PROFILE_USER_INFO_OPEN_PROFILE_BUTTON =
  'profileUserInfoOpenProfileButton'

export const QA_NAME_PROFILE_USER_INFO_CONTACT_COPY_BUTTON =
  'profileUserInfoContactCopyButton'

export const PROFILE_USER_CARD_COPY_RESET_TIMEOUT = 5000

export const PROFILE_USER_CARD_COPY_TOOLTIP_KEY = {
  copied: 'RequestProfile.WidgetUserCardCopiedTooltipKey',
  email: 'RequestProfile.WidgetUserCardClickToCopyEmailTooltipKey',
  phone: 'RequestProfile.WidgetUserCardClickToCopyPhoneTooltipKey',
}

export const PROFILE_USER_CARD_COPY_NOTIFICATION_KEY = {
  email: 'Notification.RequestProfileWidgetUserCardEmailCopiedKey',
  phone: 'Notification.RequestProfileWidgetUserCardPhoneCopiedKey',
}

export const PROFILE_USER_CARD_CONTACT_TYPE = {
  email: 'email',
  info: 'info',
  phone: 'phone',
  website: 'website',
}

export const PROFILE_USER_CARD_CONTACT_ICON_MAP = {
  [PROFILE_USER_CARD_CONTACT_TYPE.email]: EmailIcon,
  [PROFILE_USER_CARD_CONTACT_TYPE.info]: InformationIcon,
  [PROFILE_USER_CARD_CONTACT_TYPE.phone]: PhoneIcon,
  [PROFILE_USER_CARD_CONTACT_TYPE.website]: GlobeIcon,
}
